import { useTranslation } from "react-i18next";
import Menu from "@mui/material/Menu";
import { Zoom } from "@mui/material";
import { Text } from "@components";

const Tooltip = ({
  players = 0,
  anchorEl,
  onCloseModal,
  onAddToCart,
  onRemoveFromCart,
  playerCount,
  onPlayerCountChange,
  teeInCart = false,
  teeid,
  cartDetails,
  clubId,
  course,
  time,
}) => {
  const { t } = useTranslation("common");
  const handleCloseModal = () => onCloseModal();
  const returnPlayersCount = () => {
    let item = cartDetails?.filter((e) => e?.clubId == clubId);
    item = item?.filter((e) => e?.teeId == teeid);
    item = item?.filter((e) => e?.course == course);
    item = item?.filter((e) => e?.completeDetails?.time == time);
    let players_Count = item?.[0]?.players - 1 || 0;
    return players_Count;
  };

  const handleAddToCart = () =>
    teeInCart
      ? onRemoveFromCart(playerCount == returnPlayersCount())
      : onAddToCart();

  const handleClickCountCircle = (e, index) => {
    e.stopPropagation();
    onPlayerCountChange(index);
  };

  const CountCircle = ({
    selected = false,
    value = 0,
    handleClick = () => {},
  }) => {
    return (
      <div
        onClick={handleClick}
        className={`h-8 w-8 rounded-full flex justify-center items-center  ${
          selected
            ? "bg-buttonColor hover:cursor-default"
            : "border border-midGray hover:border-buttonColor hover:cursor-pointer"
        }`}
      >
        <Text className={`${selected ? "text-white" : "text-black"}`}>
          {value}
        </Text>
      </div>
    );
  };

  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={handleCloseModal}
      TransitionComponent={Zoom}
      PaperProps={{
        elevation: 0,
        sx: {
          overflow: "visible",
          borderRadius: "6px",
          marginTop: "2px",
          border: "solid",
          borderWidth: "0.1px",
          borderColor: "#cac2c2c4",
        },
      }}
      transformOrigin={{ horizontal: "center", vertical: "top" }}
      anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
    >
      <div className="bg-white px-4 py-2 rounded-lg w-full h-full">
        <div className="flex text-center justify-start gap-2 ">
          <Text className="text-lg font-normal">{`${t(
            "teeTime.player"
          )}:`}</Text>
          {Array.from({ length: players }, (item, index) => (
            <CountCircle
              handleClick={(e) => handleClickCountCircle(e, index)}
              selected={playerCount == index}
              value={index + 1}
            />
          ))}
        </div>
        <hr className="my-2 w-full h-[1px] bg-midGray border-none" />
        <div
          onClick={handleAddToCart}
          className="flex bg-buttonColor min-w-[160px] mt-2 rounded-md justify-center text-center p-1 hover:cursor-pointer border-buttonColor hover:border-buttonColor border hover:opacity-80"
        >
          {teeInCart ? (
            playerCount == returnPlayersCount() ? (
              <Text className="text-[17px] font-normal text-buttonTextColor">
                {t("course.remove_Cart")}
              </Text>
            ) : (
              <Text className="text-[17px] font-normal text-buttonTextColor">
                {t("course.update_Cart")}
              </Text>
            )
          ) : (
            <Text className="text-[17px] font-normal text-buttonTextColor">
              {t("course.add_Cart")}
            </Text>
          )}
        </div>
      </div>
    </Menu>
  );
};

export default Tooltip;
